module.exports = __webpack_public_path__ + "static/img/u5.6b850ac4.png";